import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import UIAssetKeys from '../UIAssetKeys';
import AnswerContainer from './AnswerContainer';
import Critter from './Critter';
import MessageGuy from './MessageGuy';
import LocalizationSoundAssetKeys from '../Localization-SoundAssetKeys';
import ABCyaLib from '@abcya/abcya_lib';

export default class InstructionsShow extends Phaser.GameObjects.Container {
  static get INSTRUCTIONS_DONE() {return 'show_done';}

  /**
   * 
   * @param {Phaser.Scene} scene 
   * @param {MessageGuy} msgGuyRef 
   */
  constructor(scene, msgGuyRef) {
    super(scene);

    this.messageGuyRef = msgGuyRef;
    this.instructionsSound = null;

    this.instructionSteps = null;
    this.instructionMessages = null;
    this.tapSpots = null;

    this.helperHand = null;

    this.exitCount = 0;

    this.instructionMessages = [
      ABCyaPhaser.Localization.instance.getLocalizedString('game_instructions.instructions_one'),
      ABCyaPhaser.Localization.instance.getLocalizedString('game_instructions.instructions_two'),
      ABCyaPhaser.Localization.instance.getLocalizedString('game_instructions.instructions_three'),
      ABCyaPhaser.Localization.instance.getLocalizedString('game_instructions.instructions_four')
    ];
    this.instructionSteps = [];
    let step;
    const gameConfig = ABCyaLib.Environment.instance.gameConfig;
    step = { call: this.showNextMessageText.bind(this), time: gameConfig.firstInstructionsTime };
    this.instructionSteps.push(step);
    step = { call: this.showNextMessageText.bind(this), time: gameConfig.secondInstructionsTime };
    this.instructionSteps.push(step);
    step = { call: this.showAnswers.bind(this), time: gameConfig.secondInstructionsTime + 50 };
    this.instructionSteps.push(step);
    step = { call: this.showNextMessageText.bind(this), time: gameConfig.thirdInstructionsTime };
    this.instructionSteps.push(step);
    step = { call: this.showTapHand.bind(this), time: gameConfig.thirdInstructionsTime + 50 };
    this.instructionSteps.push(step);
    step = { call: this.showNextMessageText.bind(this), time: gameConfig.fourthInstructionsTime };
    this.instructionSteps.push(step);

    /** @type {Critter[]} */
    this.fishies = [];
    this.tapSpots = [];
    this.landingSpots = [];
    const hoffset = 200;
    this.landingSpots.push({ x: 300, y: this.scene.scale.height - 200 - hoffset });
    this.landingSpots.push({ x: 500, y: this.scene.scale.height - 300 - hoffset });
    this.landingSpots.push({ x: 700, y: this.scene.scale.height - 400 - hoffset });
    const len = 3;
    let f = null;
    for (let i = 0; i < len; i++) {
      const dir = Phaser.Math.Between(0,10) > 5 ? -200 : this.scene.scale.width + 200;
      const sp = { x: dir,y: Phaser.Math.Between(60,this.scene.scale.height - 220) };
      f = new Critter(this.scene, sp, 'Fish', Phaser.Math.Between(1,9));
      this.add(f);
      this.fishies.push(f);

      const ep = this.landingSpots[i];
      f.homePos = ep;
      f.initializeSwimTo(ep.x,ep.y);
      const hp = { x: ep.x - 20,y: ep.y - 24 };
      this.tapSpots.push(hp);
    }
    this.answerDisplay = new AnswerContainer(this.scene);

    this.helperHand = ABCyaPhaser.Images.addImage(200,200, UIAssetKeys._Hand_Pointer, this).setAlpha(0)
      .setOrigin(0);

    this.instructionsSound = ABCyaPhaser.Audio.createSound(this.scene, 1, false, 0, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);
    this.instructionsSound.on(Phaser.Sound.Events.COMPLETE, this.startexit, this);
    ABCyaPhaser.Audio.playSound(LocalizationSoundAssetKeys._counting_fish_03, this.instructionsSound, 1, false, 0);
  }

  showNextMessageText () {
    if (this.instructionMessages.length > 0) {
      this.messageGuyRef.showMessage(this.instructionMessages[0], 18, false, 1800);
      this.instructionMessages.splice(0,1);
    }
  }

  showAnswers () {
    this.answerDisplay.initializeAnswerSet([1,2,3],1);
    this.answerDisplay.x = this.scene.scale.width / 2 + 40;
    this.answerDisplay.y = this.scene.scale.height - 20;
    this.add(this.answerDisplay);
  }

  showTapHand () {
    this.scene.tweens.killTweensOf(this.helperHand);

    const len = this.tapSpots.length;
    const tweenLen = 280;
    for (let i = 0; i < len; i++) {
      const index = i;
      ABCyaPhaser.Tweens.addTween(this.helperHand, tweenLen, { delay: (tweenLen + 200) * index * 2,
        scale: 1,
        alpha: 1,
        onStart: () => this.helperHand.setPosition(this.tapSpots[index].x,this.tapSpots[index].y).setScale(1.4)
          .setAlpha(0) }, Phaser.Math.Easing.Quadratic.Out, () => this.highlightFish(index));
    }
    ABCyaPhaser.Tweens.addTween(this.helperHand, 220, { delay: (tweenLen + 200) * 2 * len + 280, scale: 1.6, alpha: 0 }, Phaser.Math.Easing.Quadratic.Out);
  }

  highlightFish (value) {
    this.fishies[value].highlight();
  }

  startexit () {
    this.instructionsSound.destroy();
    this.instructionsSound = null;
    const len = this.fishies.length;
    let scatterDir;
    for (let i = 0; i < len; i++) {
      const f = this.fishies[i];
      f.removeAllListeners();
      f.on('FISH_ARRIVED_TO_DEST', this.doneWithFish, this);
      scatterDir = Phaser.Math.Between(0,100) < 50 ? 1 : -1;
      const dx = scatterDir > 0 ? this.scene.scale.width + 100 : -100;
      scatterDir = Phaser.Math.Between(0,100) < 50 ? 1 : -1;
      const dy = scatterDir > 0 ? Phaser.Math.Between(0,this.scene.scale.height / 2) : (this.scene.scale.height / 2,this.scene.scale.height);
      f.initializeSwimTo(dx,dy);
    }

    this.answerDisplay.doneWithAnswers();
  }

  doneWithFish () {
    this.exitCount++;
    if (this.exitCount >= 3) {
      this.emit(InstructionsShow.INSTRUCTIONS_DONE);
    }
  }

  soundTimeUpdate (time) {
    if (this.instructionSteps.length <= 0) return;
    if (time > this.instructionSteps[0].time) {
      this.instructionSteps[0].call();
      this.instructionSteps.splice(0,1);
    }
  }

  tick (delta) {
    const len = this.fishies.length;
    for (let i = 0; i < len; i++) {
      this.fishies[i].tick(delta);
    }
    if (this.instructionsSound) this.soundTimeUpdate(this.instructionsSound.seek * 1000);
  }
}